import React, { useEffect, useMemo, useState } from "react";
import {
    Col,
    Container,
    Modal,
    Row,
    Spinner,
    Table
} from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { Divider, Button, Popup, Form, Loader, Dimmer } from "semantic-ui-react";
import axios from "axios";
import { Toast } from "../component/Toast";

export const VoucherProduct = () => {
    const navigate = useNavigate()
    const location = useLocation().state
    const [data, setData] = useState([])
    const [modalAdd, setModalAdd] = useState(false)
    const [productWebData, setProductWebData] = useState([])
    const [selectedProducts, setSelectedProducts] = useState([])
    const [loadProduct, setLoadProduct] = useState(false)
    const [loadingTable, setLoadingTable] = useState(true)
    const [searchProduct, setSearchProduct] = useState('')
    const [pageSize, setPageSize] = useState(10)
    const [pageIndex, setPageIndex] = useState(0)
    const [gotoPageInput, setGotoPageInput] = useState('1')

    const removeProduct = (id_product, id_voucher) => {
        const param = {
            id_product : id_product,
            id_voucher : id_voucher
        }

        axios ({
            method:"POST",
            url:`${global.SRV}api_hoops_cms/controler/voucher.php/?index=11`,
            headers:{'Content-Type': 'application/json'},
            data:param
        })
        .then ( res => {
            if (res.data.state === 200){
                Toast.fire({
                    icon:'success',
                    text : 'Success remove product from this voucher',
                    position: 'center'
                })
                getProductVoucher(id_voucher)
            }
        })
    }

const getProductWeb = async () => {
    setLoadProduct(true)

    try {
        const res = await axios.get(
            "https://hoopsdevteam.com/api_web/controler/cms.php?index=2"
        )

        if (res.data.state === 200) {
            const filteredProducts = res.data.data.filter(
                i => !data.some(x => x.id_product === i.id_product)
            )

            setProductWebData(filteredProducts)
        }
    } catch (error) {
        console.error(error)
    } finally {
        setLoadProduct(false)
    }
}

const handleSubmit = () => {
    if (selectedProducts.length === 0) return

    const param = {
        id_products: selectedProducts,
        id_voucher: location.id_voucher
    }

    axios({
        method: "POST",
        url: `${global.SRV}api_hoops_cms/controler/voucher.php/?index=10`,
        headers: { 'Content-Type': 'application/json' },
        data: param
    })
    .then(res => {
        if (res.data.state === 200) {
            Toast.fire({
                icon: 'success',
                text: `Success adding ${selectedProducts.length} products to voucher`,
                position: 'center'
            })

            setModalAdd(false)
            setSelectedProducts([])
            getProductVoucher(location.id_voucher)
        } else {
            Toast.fire({
                icon: 'error',
                text: res.data.message || 'Failed adding product to voucher',
                position: 'center'
            })
        }
    })
    .catch(error => {
        console.error(error)

        Toast.fire({
            icon: 'error',
            text: 'Failed adding product to voucher',
            position: 'center'
        })
    })
}

    const getProductVoucher = async (id_voucher) => {
        setLoadingTable(true)

        try {
            const res = await axios({
                method: "GET",
                url: `${global.SRV}api_hoops_cms/controler/voucher.php/?index=9&id=${id_voucher}`
            })

            if (res.data.state === 200) {
                setData(res.data.data)
            } else {
                setData([])
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoadingTable(false)
        }
    }

    const showModalAdd = () => {
        setSelectedProducts([])
        setModalAdd(true)
        getProductWeb()
    }

    useEffect(() => {
        let id_voucher = location.id_voucher
        getProductVoucher(id_voucher)
    },[location.id_voucher])

    // Search seluruh kolom
    const filteredData = useMemo(() => {
        const keyword = searchProduct.toLowerCase().trim()

        if (!keyword) return data

        return data.filter(item =>
            [
                item.id_product,
                item.product_name,
                item.qty,
                item.price
            ].some(value =>
                String(value ?? '').toLowerCase().includes(keyword)
            )
        )
    }, [data, searchProduct])

    // Pagination calculation
    const pageCount = Math.ceil(filteredData.length / pageSize)

    const currentPage = Math.min(
        pageIndex,
        Math.max(pageCount - 1, 0)
    )

    const paginatedData = useMemo(() => {
        const start = currentPage * pageSize

        return filteredData.slice(start, start + pageSize)
    }, [filteredData, currentPage, pageSize])

    // Reset halaman ketika search berubah
    const handleSearch = (value) => {
        setSearchProduct(value)
        setPageIndex(0)
    }

    // Goto page
    const handleGotoPage = (value) => {
        const page = Number(value)

        if (!value || !Number.isInteger(page)) {
            setPageIndex(0)
            return
        }

        const targetPage = Math.min(
            Math.max(page - 1, 0),
            Math.max(pageCount - 1, 0)
        )

        setPageIndex(targetPage)
    }

    useEffect(() => {
        setGotoPageInput(String(currentPage + 1))
    }, [currentPage])

    const productOptions = useMemo(() => {
        return productWebData.map(item => ({
            key: item.id_product,
            value: item.id_product,
            text: item.id_product
        }))
    }, [productWebData])

    const selectedProductData = useMemo(() => {
        return productWebData.filter(item =>
            selectedProducts.includes(item.id_product)
        )
    }, [productWebData, selectedProducts])
    
    return (
        <Container fluid>
            <Modal size="lg" show={modalAdd} onHide={() => setModalAdd(false)} autoFocus backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Adding Product</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={12}>
                        <Dimmer active={loadProduct} inverted>
                            <Loader inverted content='Loading Product' size="tiny"/>
                        </Dimmer>
                            <Form widths="equal" onSubmit={handleSubmit}>

                                <Form.Select
                                    label="Select Article"
                                    placeholder="Search product ID..."
                                    search
                                    multiple
                                    selection
                                    clearable
                                    options={productOptions}
                                    value={selectedProducts}
                                    onChange={(e, { value }) => setSelectedProducts(value)}
                                />

                                {selectedProductData.length > 0 && (
                                    <div className="selected-products-wrapper mt-4">

                                        <div className="selected-products-header">
                                            <div>
                                                <div className="selected-products-title">
                                                    Selected Products
                                                </div>
                                                <div className="selected-products-subtitle">
                                                    Products selected for this voucher
                                                </div>
                                            </div>

                                            <span className="selected-products-count">
                                                {selectedProductData.length} Products
                                            </span>
                                        </div>

                                        <div className="selected-products-table-wrapper">
                                            <Table responsive hover className="selected-products-table mb-0">
                                                <thead>
                                                    <tr>
                                                        <th width="30%">ID PRODUCT</th>
                                                        <th>PRODUCT NAME</th>
                                                        <th width="75" className="text-center">ACTION</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {selectedProductData.map(item => (
                                                        <tr key={item.id_product}>
                                                            <td>
                                                                <span className="product-id-text">
                                                                    {item.id_product}
                                                                </span>
                                                            </td>

                                                            <td>
                                                                <span className="product-name-text">
                                                                    {item.product_name}
                                                                </span>
                                                            </td>

                                                            <td className="text-center">
                                                                <Button
                                                                    icon="trash"
                                                                    basic
                                                                    circular
                                                                    size="mini"
                                                                    color="red"
                                                                    type="button"
                                                                    className="remove-product-btn"
                                                                    title="Remove product"
                                                                    onClick={() => {
                                                                        setSelectedProducts(prev =>
                                                                            prev.filter(
                                                                                id => id !== item.id_product
                                                                            )
                                                                        )
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>

                                        <div className="selected-products-footer">
                                            <span>
                                                <i className="check circle icon"></i>
                                                {selectedProductData.length} product(s) ready to add
                                            </span>
                                        </div>

                                    </div>
                                )}

                                <div className="text-end mt-3">
                                    <Button
                                        content={`Add (${selectedProducts.length})`}
                                        icon="add"
                                        color="facebook"
                                        disabled={selectedProducts.length === 0}
                                    />
                                </div>

                            </Form>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
            <Row className="mt-1 mb-3">
                <div className="text-facebook h3 mb-0">Voucher Products</div>
                <div className="text-muted">This is a list of products added to the voucher <span style={{color:'darkblue', fontWeight:'bold'}}>{location.name}</span></div>
            </Row>
            <Divider />
            <Row className="d-flex justify-content-center mb-3 mt-3">
                <Col xl={12} lg={12} md={12} sm={12}>
                    {/* Table Header */}
                    <div className="voucher-product-toolbar">
                        <div>
                            <Button content="Add Product" icon="add" color="facebook" onClick={showModalAdd}/>
                        </div>

                        <div className="voucher-product-search">
                            <div className="input-group">
                                <span className="input-group-text">
                                    <i className="search icon" style={{height: "1.5em"}}></i>
                                </span>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search products..."
                                    value={searchProduct}
                                    onChange={(e) => handleSearch(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="voucher-product-card">

                        {/* Table */}
                        <div className="voucher-product-table-wrapper">
                            {loadingTable ? (
                                <div className="voucher-product-loading">
                                    <Spinner animation="border" size="sm" />
                                    <span>Loading products...</span>
                                </div>
                            ) : (
                                <Table
                                    hover
                                    responsive
                                    className="voucher-product-table mb-0"
                                >
                                    <thead>
                                        <tr>
                                            <th>ID PRODUCT</th>
                                            <th>PRODUCT NAME</th>
                                            <th className="text-center">QTY</th>
                                            <th>BASE PRICE</th>
                                            <th className="text-center">ACTION</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {paginatedData.length > 0 ? (
                                            paginatedData.map((item, index) => (
                                                <tr key={item.id_product || index}>
                                                    <td>
                                                        <span className="voucher-product-id">
                                                            {item.id_product}
                                                        </span>
                                                    </td>

                                                    <td>
                                                        <span className="voucher-product-name">
                                                            {item.product_name}
                                                        </span>
                                                    </td>

                                                    <td className="text-center">
                                                        <span className="voucher-product-qty">
                                                            {item.qty}
                                                        </span>
                                                    </td>

                                                    <td>
                                                        <span className="voucher-product-price">
                                                            Rp {item.price}
                                                        </span>
                                                    </td>

                                                    <td className="text-center">
                                                        <Popup
                                                            size="mini"
                                                            content="Remove this product"
                                                            trigger={
                                                                <Button
                                                                    icon="eraser"
                                                                    basic
                                                                    size="mini"
                                                                    className="voucher-remove-btn"
                                                                    onClick={() =>
                                                                        removeProduct(
                                                                            item.id_product,
                                                                            location.id_voucher
                                                                        )
                                                                    }
                                                                />
                                                            }
                                                        />
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={5}>
                                                    <div className="voucher-product-empty">
                                                        <img
                                                            src={require("../../assets/no_data.png")}
                                                            width={110}
                                                            height={110}
                                                            alt="No data"
                                                        />
                                                        <div className="voucher-empty-title">
                                                            {searchProduct
                                                                ? 'No matching products'
                                                                : 'No products found'}
                                                        </div>
                                                        <div className="voucher-empty-subtitle">
                                                            {searchProduct
                                                                ? 'Try another product name or ID'
                                                                : 'There are no products assigned to this voucher yet'}
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            )}
                        </div>

                        {/* Pagination */}
                        {!loadingTable && (
                            <div className="voucher-product-pagination">

                                <div className="voucher-pagination-left">

                                    <div className="voucher-pagination-control">
                                        <span>Show</span>

                                        <select
                                            className="form-select form-select-sm voucher-page-size"
                                            value={pageSize}
                                            onChange={(e) => {
                                                setPageSize(Number(e.target.value))
                                                setPageIndex(0)
                                            }}
                                        >
                                            {[5, 10, 20, 50, 100].map(size => (
                                                <option key={size} value={size}>
                                                    {size}
                                                </option>
                                            ))}
                                        </select>

                                        <span>entries</span>
                                    </div>

                                    <div className="voucher-pagination-summary">
                                        Showing <strong>
                                            {filteredData.length > 0
                                                ? currentPage * pageSize + 1
                                                : 0}
                                        </strong>
                                        {' - '}
                                        <strong>
                                            {Math.min(
                                                (currentPage + 1) * pageSize,
                                                filteredData.length
                                            )}
                                        </strong>
                                        {' of '}
                                        <strong>{filteredData.length}</strong>
                                    </div>

                                </div>

                                <div className="voucher-pagination-right">

                                    <div className="voucher-goto-page">
                                        <span>Go to page</span>
                                        <input
                                            type="number"
                                            className="form-control form-control-sm"
                                            min={1}
                                            max={pageCount || 1}
                                            value={gotoPageInput}
                                            disabled={pageCount === 0}
                                            onChange={(e) => setGotoPageInput(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    handleGotoPage(gotoPageInput)
                                                }
                                            }}
                                            onBlur={() => {
                                                handleGotoPage(gotoPageInput)
                                                setGotoPageInput(String(currentPage + 1))
                                            }}
                                        />
                                    </div>

                                    <div className="voucher-page-buttons">
                                        <button
                                            type="button"
                                            title="First page"
                                            disabled={currentPage === 0 || pageCount === 0}
                                            onClick={() => setPageIndex(0)}
                                        >
                                            <i className="angle double left icon"></i>
                                        </button>

                                        <button
                                            type="button"
                                            title="Previous page"
                                            disabled={currentPage === 0 || pageCount === 0}
                                            onClick={() => setPageIndex(currentPage - 1)}
                                        >
                                            <i className="angle left icon"></i>
                                        </button>

                                        <span className="voucher-page-current">
                                            {pageCount > 0 ? currentPage + 1 : 0}
                                            <span>/</span>
                                            {pageCount}
                                        </span>

                                        <button
                                            type="button"
                                            title="Next page"
                                            disabled={
                                                currentPage >= pageCount - 1 ||
                                                pageCount === 0
                                            }
                                            onClick={() => setPageIndex(currentPage + 1)}
                                        >
                                            <i className="angle right icon"></i>
                                        </button>

                                        <button
                                            type="button"
                                            title="Last page"
                                            disabled={
                                                currentPage >= pageCount - 1 ||
                                                pageCount === 0
                                            }
                                            onClick={() => setPageIndex(pageCount - 1)}
                                        >
                                            <i className="angle double right icon"></i>
                                        </button>
                                    </div>

                                </div>
                            </div>
                        )}

                    </div>
                </Col>


            </Row>
        </Container>
    )
}